import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}partners/`;

const createSafetyDocument = (partnerId,params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${partnerId}/safety_documents`;
  var formData = new FormData()
  Object.keys(params).forEach(k => {
      if (params[k] != undefined && params[k] != null && params[k] != 'null') {
          formData.append(k, params[k])
      }
  })
  fetchData(endpointURL, 'post', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchSafetyDocument = (partnerId,id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${partnerId}/safety_documents/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchSafetyDocuments = (partnerId) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${partnerId}/safety_documents`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateSafetyDocument = (partnerId,id,params) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${partnerId}/safety_documents/${id}`;
  var formData = new FormData()
  Object.keys(params).forEach(k => {
      if (params[k] != undefined && params[k] != null && params[k] != 'null') {
          formData.append(k, params[k])
      }
  })
  fetchData(endpointURL, 'put', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteSafetyDocument = (partnerId,id) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}${partnerId}/safety_documents/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

export default {
	createSafetyDocument,
	fetchSafetyDocument,
	fetchSafetyDocuments,
	updateSafetyDocument,
	deleteSafetyDocument
};



// WEBPACK FOOTER //
// ./src/api/safety_documents.js